import { apiRequest } from "./common";

const createParent = async (data) => {
    const response = await apiRequest('post', '/parent', data);
    return response.data;
};

const deleteParent = async (id) => {
    const response = await apiRequest('delete', `/parent/${id}`);
    return response.data;
};

const getParents = async (studentId) => {
    const response = await apiRequest('get', `/parent/by-student/${studentId}`);
    return response.data;
};

const resendInvitation = async (parentId) => {
    const response = await apiRequest('post', `/parent/resend-invitation/${parentId}`);
    return response.data;
};

const resetPassword = async (data) => {
    const response = await apiRequest('post', `/set-new-password`, data);
    return response.data;
};

const sendParentEmail = async (data) => {
    const response = await apiRequest('post', `/parent/send-student-report-email`, data);
    return response.data;
};

export {
    createParent,
    getParents,
    deleteParent,
    resendInvitation,
    resetPassword,
    sendParentEmail
}